import { IMenuConfiguration } from "Dashboard/domain/IMenuConfiguration";
import MenuGroup from "./MenuGroup";

interface IProps {
  menu: IMenuConfiguration;
}

const Menu = (props: IProps) => {
  let { menu } = props;

  return (
    <div className="menu">
      {menu.group1.length > 0 && (
        <div className="menu-item1">
          <MenuGroup groupId={"group1"} items={menu.group1} />
        </div>
      )}
      {menu.group2.length > 0 && (
        <div className="menu-item2">
          <MenuGroup groupId={"group2"} items={menu.group2} />
        </div>
      )}
      {menu.group3.length > 0 && (
        <div className="menu-item3">
          <MenuGroup groupId={"group3"} items={menu.group3} />
        </div>
      )}
      {menu.group4.length > 0 && (
        <div className="menu-item4">
          <MenuGroup groupId={"group4"} items={menu.group4} />
        </div>
      )}
      {menu.group5.length > 0 && (
        <div className="menu-item5">
          <MenuGroup
            groupId={"group5"}
            hasNotification
            hasTooltip
            items={menu.group5}
          />
        </div>
      )}
    </div>
  );
};

export default Menu;
